export default "__VITE_ASSET__fac59b7d__"